import { FlyerLayoutAbstract } from './flyer-layout.abstract'
import moment from 'moment-timezone'

export default class Flyer_layout_split_t_039LayoutModel extends FlyerLayoutAbstract {
  flourishes = []

  textLayouts = {
    event_name_1: {
      top: 203,
      left: 15,
      size: 62,
      width: 290,
      height: 56,
      align: 'center'
    },
    location_1: {
      top: 278,
      right: 15,
      size: 15,
      width: 290,
      height: 18,
      align: 'right',
      nowrap: true
    },
    location_2: {
      top: 296,
      right: 15,
      size: 15,
      width: 290,
      height: 18,
      align: 'right',
      nowrap: true
    }
  }

  dateLayouts = {
    date_1: {
      top: 160,
      left: 15,
      daySize: 15,
      height: 17.5,
      width: 290,
      align: 'left'
    },
    date_2: {
      top: 175.5,
      left: 15,
      daySize: 15,
      height: 17.5,
      width: 290,
      align: 'left'
    }
  }

  constructor(flyerDesign, eventData) {
    super(flyerDesign, eventData)
    this.init()
  }

  getLocationText1() {
    const customName = this.eventData.custom_venue_name || ''
    const venueName = this.eventData.venue?.name || ''
    let formattedString = (customName.length > 0 || customName === '')
      ? customName
      : venueName || ''
    return formattedString.replace('(null)', '')
  }

  getLocationText2() {
    const street = this.eventData.venue?.street || ''
    const city = this.eventData.venue?.city || ''
    const state = this.eventData.venue?.state || ''
    const country = this.eventData.venue?.country || ''
    let formattedString = ''
    if (street) {
      formattedString = street
    } else if (city) {
      formattedString = `${city}, ${state}`
    } else if (state) {
      formattedString = `${state}, ${country}`
    } else {
      formattedString = country
    }
    return formattedString.replace('(null)', '')
  }

  dayShortSuffixForDate(date) {
    const d = moment(date).date()
    if (d > 3 && d < 21) return 'TH'
    switch (d % 10) {
      case 1: return 'ST'
      case 2: return 'ND'
      case 3: return 'RD'
      default: return 'TH'
    }
  }

  stripZerosForHour(timeStr) {
    return timeStr.replace(/^0+/, '')
  }

  numberToWord(num) {
    const words = [
      'ZERO', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE', 'TEN',
      'ELEVEN', 'TWELVE', 'THIRTEEN', 'FOURTEEN', 'FIFTEEN', 'SIXTEEN', 'SEVENTEEN', 'EIGHTEEN', 'NINETEEN', 'TWENTY',
      'TWENTY-ONE', 'TWENTY-TWO', 'TWENTY-THREE', 'TWENTY-FOUR', 'TWENTY-FIVE', 'TWENTY-SIX', 'TWENTY-SEVEN', 'TWENTY-EIGHT', 'TWENTY-NINE', 'THIRTY',
      'THIRTY-ONE', 'THIRTY-TWO', 'THIRTY-THREE', 'THIRTY-FOUR', 'THIRTY-FIVE', 'THIRTY-SIX', 'THIRTY-SEVEN', 'THIRTY-EIGHT', 'THIRTY-NINE', 'FORTY',
      'FORTY-ONE', 'FORTY-TWO', 'FORTY-THREE', 'FORTY-FOUR', 'FORTY-FIVE', 'FORTY-SIX', 'FORTY-SEVEN', 'FORTY-EIGHT', 'FORTY-NINE', 'FIFTY',
      'FIFTY-ONE', 'FIFTY-TWO', 'FIFTY-THREE', 'FIFTY-FOUR', 'FIFTY-FIVE', 'FIFTY-SIX', 'FIFTY-SEVEN', 'FIFTY-EIGHT', 'FIFTY-NINE'
    ]
    return words[num] || num.toString()
  }

  getTimeWord(dateObj) {
    let hour = parseInt(dateObj.format('hh'), 10)
    let minute = parseInt(dateObj.format('mm'), 10)
    let hourWord = this.numberToWord(hour)
    let timeWord = hourWord
    if (minute > 0) {
      let minuteWord = this.numberToWord(minute)
      timeWord = `${hourWord} ${minuteWord}`
    }
    let ampm = dateObj.format('A')
    return `${timeWord} ${ampm}`.toUpperCase()
  }

  getDateWord(dateObj) {
    return dateObj.format('dddd, MMMM D').toUpperCase()
  }

  getEndDateWord(dateObj) {
    return dateObj.format('MMMM D').toUpperCase()
  }

  getDateTexts() {
    const startDate = this.eventData.starts_at
    const endDate = this.eventData.ends_at
    const timeZone = this.eventData.timezone || 'UTC'

    const date1 = this.dateLayouts.date_1
    const date2 = this.dateLayouts.date_2

    const safeDate1Color = this.dateProps.date1Props?.color?.replace('0x', '#') || '#cccccc'
    const safeDate1Font = this.dateProps.date1Props?.font?.replace(/\s+/g, '-') || 'Arial'
    const safeDate2Color = this.dateProps.date2Props?.color?.replace('0x', '#') || '#cccccc'
    const safeDate2Font = this.dateProps.date2Props?.font?.replace(/\s+/g, '-') || 'Arial'

    let dates = []
    if (!startDate) return { type: 'date', dates }

    const start = moment.tz(startDate, timeZone)
    const end = endDate ? moment.tz(endDate, timeZone) : null

    let startDateLabel = ''
    let timeLabel = ''

    if (end) {
      const isSameDay = start.isSame(end, 'day')
      const startDateStr = this.getDateWord(start)
      const endDateStr = this.getEndDateWord(end)
      const startTimeStr = this.getTimeWord(start)
      const endTimeStr = this.getTimeWord(end)

      if (isSameDay) {
        startDateLabel = startDateStr
        timeLabel = `${startTimeStr} TO ${endTimeStr}`
      } else {
        startDateLabel = `${startDateStr} ${startTimeStr}`
        timeLabel = `TO ${endDateStr} ${endTimeStr}`
      }
    } else {
      startDateLabel = this.getDateWord(start)
      timeLabel = this.getTimeWord(start)
    }

    dates.push({
      text: startDateLabel,
      align: date1.align,
      width: date1.width,
      height: date1.height,
      left: date1.left,
      top: date1.top,
      color: safeDate1Color,
      font: safeDate1Font,
      size: date1.daySize
    })

    dates.push({
      text: timeLabel,
      align: date2.align,
      width: date2.width,
      height: date2.height,
      left: date2.left,
      top: date2.top,
      color: safeDate2Color,
      font: safeDate2Font,
      size: date2.daySize
    })

    return { type: 'date', dates }
  }
}
